<template>
  <div>

    <el-row :gutter="20">
      <el-form :inline="true"
               :model="userSearchForm"
               class="demo-form-inline">
        <el-form-item label="手机号"
                      label-width="100px">
          <el-input v-model="userSearchForm.mobile"
                    placeholder="手机号"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="帐号"
                      label-width="100px">
          <el-input v-model="userSearchForm.account"
                    placeholder="帐号"
                    clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     @click="getUserList()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-row>

          <el-table v-loading="tableLoading"
                    :data="pageInfo.records"
                    style="width: 100%">
            <el-table-column prop="id"
                             label="csmarID"
                             width="120">
            </el-table-column>
            <el-table-column prop="name"
                             label="帐号"
                             width="120">
            </el-table-column>

            <el-table-column prop="mobilePhone"
                             label="手机号"
                             width="80">
            </el-table-column>
            <el-table-column prop="realName"
                             label="姓名"
                             width="80">
            </el-table-column>

            <el-table-column prop="company"
                             label="公司">
            </el-table-column>

            <el-table-column label="操作"
                             width="150">
              <template slot-scope="scope">

                <el-button type="text"
                           @click="showReports(scope.row)"
                           size="small">报告</el-button>
                <el-button type="text"
                           @click="showUserPrice(scope.row)"
                           size="small">套餐</el-button>
              </template>

            </el-table-column>
          </el-table>

        </el-row>
        <el-row>
          <br>
          <el-pagination background
                         @current-change="getUserList"
                         layout="prev, pager, next,total"
                         :current-page="pageInfo.current"
                         :page-size="pageInfo.size"
                         :total="pageInfo.total">
          </el-pagination>

        </el-row>
      </el-col>
      <template v-if="optType==='user'">
        <el-col :span="12">
          <h5>
            添加用户
          </h5>
          <el-form style="width:400px;"
                   :model="userForm"
                   :rules="userRules"
                   ref="userForm"
                   label-width="100px">

            <el-form-item label="账号"
                          prop="name">
              <el-input v-model="userForm.account"></el-input>
            </el-form-item>
            <el-form-item label="手机号"
                          prop="mobile">
              <el-input v-model="userForm.mobile"></el-input>
            </el-form-item>
            <el-form-item label="姓名"
                          prop="name">
              <el-input v-model="userForm.name"></el-input>
            </el-form-item>

            <el-form-item label="密码"
                          prop="password">
              <el-input v-model="userForm.password"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary"
                         @click="saveUser">保存</el-button>
              <el-button @click="cancelUser">取消</el-button>
            </el-form-item>

          </el-form>
        </el-col>
      </template>
      <template v-if="optType==='report'">
        <el-col :span="12">
          <h5>
            用户报告记录
          </h5>
          <el-row>
            <el-col :span="24">
              <template>
                <el-table :data="reportPageInfo.records"
                          style="width: 100%">
                  <el-table-column prop="names"
                                   label="股票名称"
                                   width="120">
                  </el-table-column>
                  <el-table-column prop="createTime"
                                   label="创建日期"
                                   width="180">
                  </el-table-column>
                  <el-table-column label="报告类型">
                    <template slot-scope="scope">
                      {{scope.row.reportType | reportTypeFilter}}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作"
                                   width="100">
                    <template slot-scope="scope">
                      <!-- <el-button @click="toRead(scope.row.sourceId)"
                                             type="text"
                                             size="small">阅读</el-button> -->
                      <el-button type="text"
                                 @click="toDownload(scope.row.sourceId)"
                                 size="small">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>

            </el-col>
            <el-col :span="24">
              <br>
              <el-pagination background
                             @current-change="getReportList"
                             layout="prev, pager, next,total"
                             :current-page="reportPageInfo.current"
                             :page-size="reportPageInfo.size"
                             :total="reportPageInfo.total">
              </el-pagination>
            </el-col>
          </el-row>
        </el-col>
      </template>
      <template v-if="optType==='price'">
        <el-col :span="12">
          <h5>

            <el-select v-model="curAddPrice"
                       placeholder="请选择">
              <el-option v-for="item in priceTable"
                         :key="item.value"
                         :label="item.packageName"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary"
                       @click="addUserPrice()">赠送套餐</el-button>
          </h5>
          <el-row>
            <el-col :span="24">
              <template>
                <el-table :data="pricePageInfo.records"
                          style="width: 100%">
                  <el-table-column prop="packageName"
                                   label="套餐名称"
                                   width="120">
                  </el-table-column>
                  <el-table-column prop="createTime"
                                   label="购买日期"
                                   width="180">
                  </el-table-column>
                  <el-table-column label="过期时间">
                    <template slot-scope="scope">
                      {{scope.row.expireTime | dateFilter}}
                    </template>
                  </el-table-column>

                  <el-table-column label="报告类型">
                    <template slot-scope="scope">
                      {{scope.row.reportType | reportTypeFilter}}
                    </template>
                  </el-table-column>
                  <el-table-column label="文件类型"
                                   width="120">
                    <template slot-scope="scope">
                      {{scope.row.fileType|fileTypeFilter}}
                    </template>
                  </el-table-column>
                </el-table>
              </template>

            </el-col>
            <el-col :span="24">
              <br>
              <el-pagination background
                             @current-change="getPriceList"
                             layout="prev, pager, next,total"
                             :current-page="pricePageInfo.current"
                             :page-size="pricePageInfo.size"
                             :total="pricePageInfo.total">
              </el-pagination>
            </el-col>
          </el-row>
        </el-col>
      </template>
    </el-row>

  </div>
</template>

<script>

import axios from 'axios'
import moment from 'moment'
export default {
  name: 'myReports',
  data: function () {
    return {
      tableLoading: true,
      pageInfo: {
        current: 1,
        size: 5,
        records: [],
        total: 1
      },
      schoolSearchForm: {
        name: '',
        code: '',
        proxyId: ''
      },
      userSearchForm: {
        mobile: '',
        account: ''

      },
      pdfDialogVisible: false,
      pdfUrl: '',
      sourceId: '',
      activeName: 'price',
      userForm: {
        name: '',
        account: '',
        mobile: '',
        password: ''
      },
      userRules: {},
      optType: 'user',

      reportPageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      },
      curUserId: '',
      prices: [],
      accountForm: {},
      accountRule: {},
      accountTime: 0,

      taskDialogVisible: false,
      taskForm: {
        type: 'FULL'
      },
      options: [],
      candidateOptions: [],
      conceptOptions: [],
      candidateConcept: [],

      // 学校列表
      schoolPageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      },

      schoolFrom: {
        refresh: false
      },

      proxyList: [],
      pricePageInfo: {
        page: 1,
        size: 10
      },
      curAddPrice: null,
      priceTable: []

    }
  },
  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    },

    taskStatusFilter: function (v) {
      switch (v) {
        case 'TRUE':
          return '已完成'
        case 'FALSE':
          return '未完成'
        default:
          return v
      }
    },
    typeFilter: function (v) {
      switch (v) {
        case 'FULL':
          return '股票'
        case 'CONCEPT':
          return '概念'
      }
    },
    reportTypeFilter: function (v) {
      switch (v) {
        case 'ALL':
          return '所有'
        case 'FULL':
          return '个股分析（增强版）'
        case 'SIMPLE':
          return '个股分析'
        case 'TINY':
          return '个股分析简报'
        case 'CONCEPT':
          return '概念报告'
        case 'COMPARE':
          return '投资组合'
        case 'HKSTOCK':
          return '港股报告'
        default:
          break
      }
      return v
    },
    statusFilter: function (v) {
      switch (v) {
        case 'ENABLE':
          return '可用'
        case 'DISABLE':
          return '禁用'
        default:
          return v
      }
    },
    fileTypeFilter: function (v) {
      switch (v) {
        case 'PDF':
          return 'PDF'
        case 'DOC':
          return 'WORD'
        case 'ALL':
          return '所有'

        default:
          return v
      }
    },
    rolesTypeFilter: function (v) {
      switch (v) {
        case 'ADMIN':
          return '管理员'
        case 'NORMAL':
          return '注册用户'
        case 'VIP':
          return 'VIP用户'
        case 'SVIP':
          return '超级VIP'
        default:
          return v
      }
    }
  },
  methods: {
    addUserPrice () {
      let _this = this
      axios.get('/api/web/admin/addUserPrice?userId=' + this.curUserId + '&priceId=' + this.curAddPrice).then(resp => {
        this.$message({
          message: '用户套餐添加成功',
          type: 'success'
        })
        _this.getPriceList()
      })
    },
    showReports (row) {
      this.optType = 'report'
      this.curUserId = row.systemId
      this.reportPageInfo.current = 1
      this.reportPageInfo.records = []
      this.getReportList()
    },
    showUserPrice (row) {
      this.optType = 'price'
      this.curUserId = row.systemId
      this.pricePageInfo.current = 1
      this.pricePageInfo.records = []
      this.getPriceList()
    },
    getReportList () {
      let _this = this
      axios.get('/api/web/admin/reports?page=' + this.reportPageInfo.current + '&pageSize=' + this.reportPageInfo.size + '&userId=' + this.curUserId).then(resp => {
        _this.reportPageInfo = resp.data
        _this.reportPageInfo.total = parseInt(_this.reportPageInfo.total)
        _this.reportPageInfo.current = parseInt(_this.reportPageInfo.current)
        _this.reportPageInfo.size = parseInt(_this.reportPageInfo.size)
      })
    },
    getPriceList () {
      let _this = this
      axios.get('/api/web/admin/userPrices?page=' + this.pricePageInfo.current + '&pageSize=' + this.pricePageInfo.size + '&userId=' + this.curUserId).then(resp => {
        _this.pricePageInfo = resp.data
        _this.pricePageInfo.total = parseInt(_this.reportPageInfo.total)
        _this.pricePageInfo.current = parseInt(_this.reportPageInfo.current)
        _this.pricePageInfo.size = parseInt(_this.reportPageInfo.size)
      })
    },

    saveUser () {
      axios.post('/api/web/admin/saveCsmarUser', this.userForm).then(resp => {
        this.getUserList()
        this.userForm = {}
        this.$message({
          message: '用户信息修改成功',
          type: 'success'
        })
      })
    },

    cancelUser () {
      this.userForm = {}
      this.getUserList()
    },
    toRead (sourceId) {
      this.sourceId = sourceId
      this.pdfUrl = '/api/web/stock/readPdf/' + sourceId
      this.pdfDialogVisible = true
    },
    toDownload (sourceId) {
      window.open('/api/web/admin/downLoadPdf/' + sourceId)
    },
    getUserList (val) {
      if (val) {
        this.pageInfo.current = val
      }
      let _this = this
      axios.get('/api/web/admin/csmarUser?page=' + this.pageInfo.current +
        '&pageSize=' + this.pageInfo.size +
        '&mobile=' + this.userSearchForm.mobile +
        '&account=' + this.userSearchForm.account
      ).then(resp => {
        _this.pageInfo = resp.data
        _this.pageInfo.total = parseInt(_this.pageInfo.total)
        _this.pageInfo.current = parseInt(_this.pageInfo.current)
        _this.pageInfo.size = parseInt(_this.pageInfo.size)
        _this.tableLoading = false
      })
    }
  },
  components: {

  },
  mounted () {
    this.getUserList(1)

    let _this = this
    axios.get('/api/web/admin/priceList').then(resp => {
      _this.priceTable = resp.data
    })
  },
  watch: {
    accountTime () {
      this.accountForm.time = this.accountTime
      this.accountForm.expireTime = new Date().getTime() + this.accountTime * 24 * 60 * 60 * 1000
    }
  }
}
</script>
<style scope>
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/csmarUser .vue